import Joi from "joi";
export const branchSchema = Joi.object({
    branch_name: Joi.string()
        .min(3)
        .max(255)
        .required()
        .messages({
            "any.required": "Branch Name is required.",
            "string.empty": "Branch Name is required.",
            "string.min": "Branch Name must be at least 3 characters.",
            "string.max": "Branch Name must not exceed 255 characters.",
        }),
    contact_number: Joi.string()
        .required()
        .custom((value, helpers) => {
            const trimmedValue = value.toString().trim();
            if (trimmedValue !== "" && !/^\d{10,11}$/.test(trimmedValue)) {
                return helpers.error("any.invalid");
            }
            return trimmedValue;
        })
        .messages({
            "string.pattern.base": "Invalid phone number format",
            "string.empty": "Branch Contact is required",
            "any.required": "Branch Contact is required.",
            "any.invalid": "Invalid Landline number format."
        }),
    contact_person: Joi.string().min(3).max(255).allow("").messages({
        "string.min": "contact person number must be at least 3 characters.",
        "string.max": "contact person must not exceed 500 characters.",

    }),
    email: Joi.string()
        .email({ tlds: { allow: false } })
        .required()
        .messages({
            "string.pattern.base": "Invalid phone number format",
            "string.base": "Email is required.",
            "string.required": "Email is required.",
            "string.invalid": "Email is required.",
            "string.empty": "Email is required.",
            "string.email": "Please provide a valid email address.",
        }),
    date_of_est: Joi.date().allow(null, "").messages({
        "date.base": "Invalid date format.",
    }),
    address: Joi.string().min(5).max(500).allow("").messages({
        "any.invalid": "Address is required.",
        "string.min": "Address must be at least 5 characters.",
        "string.max": "Address must not exceed 500 characters.",
    }),
    locality: Joi.string().min(2).max(300).allow("").messages({
        "any.invalid": "Address is required.",
        "string.min": "Locality must be at least 2 characters.",
        "string.max": "Locality must not exceed 300 characters.",
    }),
    city: Joi.string().min(3).max(300).allow("").messages({
        "any.invalid": "City is required.",
        "string.min": "City must be at least 3 characters.",
        "string.max": "City must not exceed 300 characters.",
    }),
    state: Joi.number().integer().min(1).allow(null, "").messages({
        "number.base": "State must be a valid number.",
    }),
    country: Joi.string().min(3).max(100).allow("").messages({
        "string.min": "Country must be at least 3 characters.",
        "string.max": "Country must not exceed 100 characters.",
    }),
    pincode: Joi.number().integer().min(100000).max(999999).allow("").messages({ 'number.base': 'Pincode must be a number.', 'number.min': 'Pincode must be a 6-digit number.', 'number.max': 'Pincode must be a 6-digit number.' }),
    landmark: Joi.string().min(3).max(300).allow("").messages({
        "string.min": "Landmark must be at least 3 characters.",
        "string.max": "Landmark must not exceed 300 characters.",
    }),
});
